<script>
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import FCInput from '../FCInput.vue';

export default {
  name: 'LinkAccountRequestCard',
  components: {
    FCInput,
  },
  setup() {
    const email = ref('');
    const isLoading = ref(false);
    const store = useStore();
    const isEmailSent = computed(() => store.state.linkingEmailSent);

    const handleLinking = async () => {
      isLoading.value = true;
      await store.dispatch('generateLinkAccountUrl', email.value);
      isLoading.value = false;
    };

    return {
      email,
      isLoading,
      isEmailSent,
      handleLinking,
    };
  },
};
</script>

<template>
  <div class="link-account-request-card" v-track-view="'LinkAccountRequestCard'">
    <div class="link-account-request-card__header">
      <h2 class="link-account-request-card__title">Link subscription to your account</h2>
      <p class="link-account-request-card__text">
        If you have a subscription under a different email, we will send an email to that
        address to facilitate linking your account.
      </p>
    </div>

    <div v-if="isEmailSent" class="link-account-request-card__confirmation">
      <p v-track-view="'LinkAccountRequestCard_Confirmation'">
        Email sent! Please ask the recipient to forward you the email they received.
        Click the link in the email to join their subscription and activate your hardware.
      </p>
    </div>

    <form v-else class="link-account-request-card__form" @submit.prevent="handleLinking">
      <p class="link-account-request-card__form-label">
        Enter the email address used at checkout to link an existing subscription.
      </p>
      <FCInput
        v-model="email"
        class="link-account-request-card__input"
        name="email"
        title="Email"
        :required="true"
        :disabled="isLoading"
      />
      <button
        type="submit"
        class="link-account-request-card__button button-normal button-layout button-cta"
        v-track-click="'LinkAccountRequestCard_SendEmail'"
        :disabled="isLoading"
      >
        <font-awesome-icon icon="spinner" spin v-if="isLoading" />
        <span v-else>Send Email</span>
      </button>
    </form>
  </div>
</template>

<style lang="scss" scoped>
.link-account-request-card {
  background-color: $color-white;
  border-radius: $input-radius;
  box-shadow: 0 0.25rem 0.5rem rgba(15, 30, 60, 0.1);
  padding: 2rem;
  max-width: 600px;

  &__title {
    font-family: $font-stack-heading;
    font-size: 1.25rem;
    text-transform: uppercase;
    margin: 0 0 0.75rem;
    color: $color-black;
    letter-spacing: 0.02em;
  }

  &__text {
    font-size: 0.875rem;
    color: $fc-greyscale-800;
    margin: 0 0 1.5rem;
  }

  &__form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  &__form-label {
    font-size: 0.875rem;
    color: $fc-greyscale-800;
    margin: 0;
  }

  &__button {
    align-self: flex-start;
    padding: 0.75rem 1.5rem;
  }

  &__confirmation {
    font-size: 0.875rem;
    color: $fc-greyscale-800;
  }
}
</style>
